import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import styled from 'styled-components';
var StyledWrapper = styled.div.withConfig({
  displayName: "ButtonGroup__StyledWrapper",
  componentId: "sc-1pj9qju-0"
})(["display:flex;flex:1;flex-wrap:wrap;justify-content:", ";", ""], function (_ref) {
  var $alignment = _ref.$alignment;
  return $alignment || 'space-between';
}, function (_ref2) {
  var $context = _ref2.$context;
  return $context === 'floating' ? " position: absolute;\n        right: 0.5rem;\n        top: 0.5rem;\n        z-index: 1;" : "";
});
var alignmentMap = {
  center: 'center',
  even: 'space-evenly',
  left: 'flex-start',
  right: 'flex-end'
};

var ButtonGroup = function ButtonGroup(_ref3) {
  var align = _ref3.align,
      context = _ref3.context,
      getBodySlot = _ref3.getBodySlot,
      body = _ref3.body,
      children = _ref3.children,
      className = _ref3.className,
      e2e = _ref3.e2e;
  var bodyCb = React.useCallback(function (node) {
    getBodySlot && getBodySlot(node);
  }, [getBodySlot]);
  return /*#__PURE__*/React.createElement(StyledWrapper, _extends({
    className: className
  }, e2e && {
    'data-e2e': e2e
  }, {
    $alignment: align ? alignmentMap[align] : undefined,
    $context: context
  }), /*#__PURE__*/React.createElement("span", _extends({
    ref: bodyCb
  }, e2e && {
    'data-e2e': "".concat(e2e, "-body")
  }), body, children));
};

export default ButtonGroup;

try {
  ButtonGroup.__docgenInfo = {
    description: '',
    displayName: 'ButtonGroup',
    methods: [],
    props: {
      align: {
        defaultValue: null,
        description: '',
        name: 'align',
        required: false,
        type: {
          name: 'enum',
          raw: '"center" | "even" | "left" | "right"',
          value: [{
            value: '"center"'
          }, {
            value: '"even"'
          }, {
            value: '"left"'
          }, {
            value: '"right"'
          }]
        }
      },
      body: {
        defaultValue: null,
        description: '',
        name: 'body',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        required: false,
        type: {
          name: 'string'
        }
      },
      context: {
        defaultValue: null,
        description: '',
        name: 'context',
        required: false,
        type: {
          name: '"floating"'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      getBodySlot: {
        defaultValue: null,
        description: '',
        name: 'getBodySlot',
        required: false,
        type: {
          name: '(elem: HTMLElement) => any'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map